// import { Footer } from "../components/blocks/Footer";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ArgoneLogo from "../logo.svg";
// import { useDispatch } from "react-redux";
import { ForgotAdminPassword } from "../utils/Api/ApiCalls";
import { ClipLoader } from "react-spinners";
import Swal from "sweetalert2";
// import { addUser } from "../services/reducers";
// import { addUser } from "../services/reducers";

const ForgotPassword = () => {
  const Navigate = useNavigate();
  // const dispatch = useDispatch();
  const [load, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false); // State to manage password visibility
  const [formData, setFormData] = useState({
    Email: "",
  });

  const onChangeForm = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const ForgotUserSubmit = async () => {
    setLoading(true);
    try {
      const res = await ForgotAdminPassword(formData);
      
      if (res?.response?.data?.message) {
        Swal.fire({
          icon: "error",
          title: `${res?.response?.data?.message}`,
          timer: 3000,
          showConfirmButton: false,
        });
      } else {
        Swal.fire({
          icon: "success",
          title: `${res?.message}`,
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          Navigate("/login");
        });
      }
      // Navigate("/");
      setLoading(false);
      // dispatch(addUser(res?.data?.data?.info));
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "An error occurred",
        timer: 3000,
        showConfirmButton: false,
      });
      setLoading(false);
      return err;
    }
  };
  return (
    <main className="main pages">
      <div className="page-content pt-150 pb-150">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 m-auto">
              <div className="row">
                <div>
                  <div className="card">
                    <div className="card-header">
                      <p>
                        <img src={ArgoneLogo} alt="Argone-logo" />
                      </p>
                      <h5>ForgotPassword</h5>
                    </div>
                    <div className="card-body">
                      <p style={{ marginBottom: "20px" }}>
                        Enter email to reset password
                      </p>
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          ForgotUserSubmit();
                        }}
                        name="enq"
                      >
                        <div className="row">
                          <div className="form-group col-md-12">
                            <label>
                              Email <span className="required">*</span>
                            </label>
                            <input
                              required
                              className="form-control"
                              name="email"
                              type="email"
                              onChange={onChangeForm}
                            />
                          </div>
                          {load ? (
                            <div style={{ marginTop: "20px" }} class="mb-4">
                              <button
                                disabled
                                type="submit"
                                class="btn btn-primary w-100"
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    // justifyContent: "space-between",
                                    justifyContent: "center",
                                    width: "100%",
                                    alignItems: "center",
                                  }}
                                >
                                  <div>Loading... </div>
                                  <span>
                                    <ClipLoader color="white" size={15} />
                                  </span>
                                </div>
                              </button>
                            </div>
                          ) : (
                            <div style={{ marginTop: "20px" }} class="mb-4">
                              <button
                                type="submit"
                                class="btn btn-primary w-100"
                                style={{
                                  display: "flex",
                                  // justifyContent: "space-between",
                                  justifyContent: "center",
                                  width: "100%",
                                  alignItems: "center",
                                }}
                              >
                                Submit
                              </button>
                            </div>
                          )}
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </main>
  );
};

export default ForgotPassword;
